import React from 'react';
import { getAppCfg } from './release/utils/common';
export const domainName = document._portalConfig.customer;
export const connection ={
    crmConfig : {
        cookiesConfig:{
            secure: false,
           // path: document._basePath,
           // sameSite: 'None',
            expires: 0
        },
        basename: document._portalConfig.basePath,
        publicPath: document._portalConfig.publicPath ,//set to /web or /uat when deploy
        defaultCrmServer: document._portalConfig.crmServer,
        isOpenPaypal: document._portalConfig.isOpenPaypal,
        paypalIntegration: document._portalConfig.paypalIntegration,
        secure: false,
        sslCertificates: ["pr6","hellenicbankcom","hellenic_prod"],
        isOpenFAC: document._portalConfig.isOpenFAC,
        facIntegration: document._portalConfig.facIntegration,
        isOpenStripe: document._portalConfig.isOpenStripe,
        stripeIntegration: document._portalConfig.stripeIntegration,
        useOrderCountry: document._portalConfig.useOrderCountry,
        defaultCountry: document._portalConfig.defaultCountry,
    }
}
export const portal_config = {
    apiKey:'AIzaSyASJk1hzLv6Xoj0fRsYnfuO6ptOXu0fZsc',
    webClientId: '89090741580-ecfsd2kfak4buvcldi699n5233aul8nd.apps.googleusercontent.com',
    default_currency: ' ',
    copyright:'© CRM.COM',
    isLocationVN: false,
    isShowVersion: true,

    airlink: {
        app_name: 'Airlink',
        logoStyle: 'square',
        logoDimension: {
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo: false,
        landingPageLogo: true,
        usingLocalTheme: false,
        usingLocalIcon: false,
        landingPageBackgroundColor: false,
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont: {
            home: false,
            offer: true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,        
        facIntegration: document._portalConfig.facIntegration,
        showInvoicePage: true,
        isShowServiceChanges: true,
    },
    buyway:{
        app_name:'Buyway',
        logoStyle:'square',
        logoDimension:{
            width: 240,
            height: 100,
            objectFit:'contain'
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:true,
        landingPageLogo: true,
        usingLocalTheme:true,
        usingLocalIcon:false,
        landingPageBackgroundColor:true, 
        referFriend: false,
        isCredentials: false,
        replaceIconWithFont:{
            home: true,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: true,
        showOnlineShope: true,
        customColorIcon: "#00A2E1",
        customColorWalletFee:"#00a2e0",
        isOrderWithFilterMerchant: true,//only for buyway
    },
    coffeedirect: {
        app_name: 'Coffee Direct',
        logoStyle: 'rounded',
        logoDimension: {
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo: false,
        landingPageLogo: true,
        usingLocalTheme: false,
        usingLocalIcon: false,
        landingPageBackgroundColor: false,
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont: {
            home: false,
            offer: true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false
    },
    coffeehouse:{
        app_name:'Coffee House',
        logoStyle:'rounded',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: false,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        triggerCheckFavouriteStore: true,
        customCountries:["GRC","CYP"]
    },
    release:{
        app_name:'Release app',
        logoStyle:'rounded',
        logoDimension:{
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
        showUploadFileSR: true,
        showInvoicePage: false,
    },
    costacoffee:{
        app_name:'Costa Coffee',
        logoStyle:'rounded',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:true,
        landingPageLogo: true,
        usingLocalTheme:true,
        usingLocalIcon:true,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        custom_page:{
            home: true,
        }
    },
    checkin:{
        app_name:'Check in',
        logoStyle:'rounded',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,
    
        // checkin
        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: false,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: true,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: false,
    },
    cignal:{
        app_name:'Cignal',
        logoStyle:'square',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:true, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
        showInvoicePage: true,
        isShowServiceChanges: true,
    },
    ipharmcy:{
        app_name:'I Pharmcy',
        logoStyle:'square',
        logoDimension:{
            width: 200,
            height: 200,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: false,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: false,
        headerLocalColor: false,
        textPriLocalColor: true,
        publicPagePrimaryColor: true,
        splashColor: '#7ed321'
    },
    mikel:{
        app_name:'Mikel',
        logoStyle:'square',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        // landingPageBackgroundColor:{
        //     logo: false,
        //     color: getAppCfg()&&getAppCfg().appearance&&getAppCfg().appearance.background_color?getAppCfg().appearance.background_color:null
        // }, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false
    },
    homespot:{
        app_name:'Homespot app',
        logoStyle:'square',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
    },
    ventuno:{
        app_name:'Ventuno app',
        logoStyle:'square',
        logoDimension:{
            width: 100,
            height: 100,
        },
        applyFontPerLanguage:false,
        isOfferFilter: true,
        allowForChangeMerchant:true,
        isBigMapFullDisplay: true,
        facebook_app_id: "1070031819833540",
        google_client_id:"",
        isRegisterCountry: true,

        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:{
            logo: false,
            color: getAppCfg()&&getAppCfg().appearance&&getAppCfg().appearance.background_color?getAppCfg().appearance.background_color:null
        },
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
    },
    prestabist: {
        app_name: 'Prestabist',
        logoStyle: 'square',
        logoDimension: {
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo: false,
        landingPageLogo: true,
        usingLocalTheme: false,
        usingLocalIcon: false,
        landingPageBackgroundColor: false,
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont: {
            home: false,
            offer: true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false
    },
    etv: {
        app_name: 'eTV',
        logoStyle: 'square',
        logoDimension: {
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo: false,
        landingPageLogo: true,
        usingLocalTheme: false,
        usingLocalIcon: false,
        landingPageBackgroundColor: false,
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont: {
            home: false,
            offer: true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
    },
    ayna: {
        app_name:'Ayna OTT',
        logoStyle:'rounded',
        logoDimension:{
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
        showUploadFileSR: true,
        showInvoicePage: false,
        hidePauseService: true,
        hideResumeService: true,
    },
    dorplay:{
        app_name:'Dorplay',
        logoStyle:'rounded',
        logoDimension:{
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo:false,
        landingPageLogo: true,
        usingLocalTheme:false,
        usingLocalIcon:false,
        landingPageBackgroundColor:false, 
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont:{
            home: false,
            offer:true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,
        showUploadFileSR: true,
        showInvoicePage: false,
        hidePauseService: true,
        hideCancelService: true,
    },
}

export const custom_assets = {
    airlink: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
    //buyway
    buyway:{
        customIcon: true,
        customImage:{
            background:true,
            logo:true
        },
    },
    coffeedirect: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
    coffeehouse:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    release:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    costacoffee:{
        customIcon: true,
        customImage:{
            background:true,
            logo:true
        },
    },
    checkin:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    cignal:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    ipharmcy:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    mikel:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    homespot:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    ventuno:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    prestabist: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
    etv: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
    ayna: {
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    dorplay:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
}


export const address_types = [
    {
        label: "Home",
        value: 'HOME',
    },
    {
        label: "Business",
        value: 'BUSINESS',
    },
    {
        label: "Alternative",
        value: 'ALTERNATIVE'
    }
]

export const town_city = [
    {
        id: "All",
        name: 'All',//FAMAGUSTA
    },
    {
        id: "Famagusta",
        name: 'Famagusta',//FAMAGUSTA
    },
    {
        id: "Larnaca",
        name: 'Larnaca',//LARNACA
    },
    {
        id: "Limassol",
        name: 'Limassol',//LIMASSOL
    },
    {
        id: "Nicosia",
        name: 'Nicosia',//NICOSIA
    },
    {
        id: "Paphos",
        name: 'Paphos',//PAPHOS
    },
]